import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detailledgercoa',
  templateUrl: './detailledgercoa.component.html',
  styleUrls: ['./detailledgercoa.component.sass']
})
export class DetailledgercoaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
